export function copyToClipboard (text) {
    navigator.clipboard.writeText(text).then(() => {
        console.log('Copied to clipboard: ', text);
    }).catch(err => {
        console.error('Failed to copy: ', err);
    });
};

// className={`copy-icon ${copyClicked ? 'click-animation' : ''}`}